module.exports = __webpack_public_path__ + "static/media/stepsimage.443bb6db.png";